import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CrudService, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, setRequiredValidator, OtherService, prepareRequiredHttpParams, MomentService, SnackbarService, adjustDateFormatAsPerPCalendar, toRoundOffWithMathRound } from '@app/shared';
import { ProcessPaymentDetailsModel, ProcessPaymentInstallationModel } from '@modules/customer/models/process-payment-installation.model';
import { BillingModuleApiSuffixModels } from '@modules/sales';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';

@Component({
  selector: "app-process-payment-upsell-dialog",
  templateUrl: "./process-payment-upsell-dialog.component.html",
})
export class ProcessPaymentUpsellDialogComponent implements OnInit {
  processPaymentDialogForm: FormGroup;
  selectedTabIndex: number = 0;
  isLoading: boolean;
  isSubmitted: boolean;
  primengTableConfigProperties: any;
  todayDate: any = new Date();

  constructor(
    private crudService: CrudService,
    private rxjsService: RxjsService,
    private otherService: OtherService,
    private momentService: MomentService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {
    this.rxjsService.setDialogOpenProperty(true);
    this.primengTableConfigProperties = {
      tableComponentConfigs: {
        tabsList: [
          {
            dataKey: "paymentId",
            formArrayName: "paymentDetailsArray",
            columns: [
              {
                field: "paidAmount",
                displayName: "",
                type: "input_hidden",
                className: "",
                required: true,
              },
              {
                field: "paymentMethodId",
                displayName: "Payment Method",
                type: "input_select",
                className: "col-4",
                required: true,
                displayValue: "displayName",
                assignValue: "id",
                isDefaultOpt: true,
                defaultText: "Select",
                options: this.config?.data?.static_result?.paymentMethods,
              },
              {
                field: "debitDate",
                displayName: "Debit Date",
                type: "input_date",
                className:
                  "col-4 fidelity-date-picker-con fdt-date-con p-relative",
                minDate: this.todayDate,
                appendTo: "body",
              },
              {
                field: "paidAmount",
                displayName: "Amount",
                type: "input_amount",
                className:
                  "col-2 fidelity-date-picker-con fdt-date-con p-relative",
              },
            ],
            hideFormArrayAction: true,
          },
        ],
      },
    };
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit() {
    this.onLoadValue();
  }

  btnCloseClick() {
    this.ref.close();
  }

  initForm(processPaymentInstallationModel?: ProcessPaymentInstallationModel) {
    let processPaymentModel = new ProcessPaymentInstallationModel(
      processPaymentInstallationModel
    );
    this.processPaymentDialogForm = this.formBuilder.group({});
    Object.keys(processPaymentModel).forEach((key) => {
      if (
        typeof processPaymentModel[key] === "object" &&
        processPaymentModel[key] != null
      ) {
        this.processPaymentDialogForm.addControl(
          key,
          new FormArray(processPaymentModel[key])
        );
      } else {
        this.processPaymentDialogForm.addControl(
          key,
          new FormControl({ value: processPaymentModel[key], disabled: true })
        );
      }
    });
    this.processPaymentDialogForm = setRequiredValidator(
      this.processPaymentDialogForm,
      ["paymentOptionId"]
    );
    // if(this.config?.data?.paymentDetails?.resources?.isAllowedtoChangePaymentMethod) {
    //   this.processPaymentDialogForm?.get('paymentOptionId').enable();
    // }
    // this.onValueChanges();
  }

  initFormArray(processPaymentDetailsModel?: ProcessPaymentDetailsModel) {
    let processPaymentDetailModel = new ProcessPaymentDetailsModel(
      processPaymentDetailsModel
    );
    let processPaymentDetailsFormArray = this.formBuilder.group({});
    Object.keys(processPaymentDetailModel).forEach((key) => {
      if (key == "debitDate" && processPaymentDetailModel["canEdit"] == true) {
        processPaymentDetailsFormArray.addControl(
          key,
          new FormControl({
            value: processPaymentDetailModel[key],
            disabled: false,
          })
        );
      } else {
        processPaymentDetailsFormArray.addControl(
          key,
          new FormControl({
            value: processPaymentDetailModel[key],
            disabled: true,
          })
        );
      }
    });
    processPaymentDetailsFormArray = setRequiredValidator(
      processPaymentDetailsFormArray,
      ["paidAmount", "paymentMethodId", "debitDate"]
    );
    // this.getProcessPaymentFormArray.insert(0, processPaymentDetailsFormArray);
    processPaymentDetailsFormArray
      .get("debitDate")
      .valueChanges.subscribe((val: any) => {
        if (val) {
          const internalCutOffTime =
            this.config?.data?.paymentDetails.internalCutOffTime;
          if (
            this.otherService.onCutOfTimeValidation(val, internalCutOffTime)
          ) {
            processPaymentDetailsFormArray.get("debitDate").setValue(null);
            return this.snackbarService.openSnackbar(
              "Please select a different date as cut off time has reached"
            );
          }
          this.rxjsService.setGlobalLoaderProperty(true);
          this.crudService
            .get(
              ModulesBasedApiSuffix.BILLING,
              BillingModuleApiSuffixModels.VALIDATE_UPSELL_PAYMENT_DATE,
              null,
              false,
              prepareRequiredHttpParams({
                customerId: this.config?.data?.customerId,
                callInitiationId: this.config?.data?.callInitiationId,
                paymentDate: this.momentService.localToUTC(val),
              }),
              1
            )
            .subscribe((response: IApplicationResponse) => {
              if (response.isSuccess && response.statusCode === 200) {
              } else {
                processPaymentDetailsFormArray.get("debitDate").setValue(null);
              }
              this.rxjsService.setGlobalLoaderProperty(false);
            });
        }
      });
    this.getProcessPaymentFormArray.push(processPaymentDetailsFormArray);
  }

  getDateFormat() {
    return adjustDateFormatAsPerPCalendar();
  }

  get getProcessPaymentFormArray(): FormArray {
    if (!this.processPaymentDialogForm) return;
    return this.processPaymentDialogForm.get(
      "paymentDetailsArray"
    ) as FormArray;
  }

  //Clear from arry
  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  onValueChanges() {
    this.processPaymentDialogForm
      .get("paymentOptionId")
      .valueChanges.subscribe((res) => {
        if (res) {
          this.clearFormArray(this.getProcessPaymentFormArray);
          if (
            res == this.config?.data?.paymentDetails?.resources?.paymentOptionId
          ) {
            this.onPatchFormArray(this.config?.data?.paymentDetails);
          } else {
            for (let i = 0; i < res; i++) {
              const paidAmount = this.config?.data?.paymentDetails?.resources
                ?.balanceAmount
                ? toRoundOffWithMathRound(
                  +this.config?.data?.paymentDetails?.resources
                    ?.balanceAmount / res
                )
                : 0;
              this.initFormArray({
                paidAmount: +paidAmount,
                paymentMethodId: "",
                debitDate: null,
                canEdit: false,
                isDebitOrder: false,
              });
            }
          }
        }
      });
  }

  onLoadValue() {
    setTimeout(() => {
      this.patchValue(this.config?.data?.paymentDetails);
    }, 100);
  }

  patchValue(res) {
    this.processPaymentDialogForm.patchValue(
      {
        paymentTransactionId: res?.resources?.paymentTransactionId
          ? res?.resources?.paymentTransactionId
          : "",
        quotationVersionId: res?.resources?.quotationVersionId
          ? res?.resources?.quotationVersionId
          : "",
        balanceAmount: res?.resources?.balanceAmount
          ? this.otherService?.transformDecimal(res?.resources?.balanceAmount)
          : "",
        isAllowedtoChangePaymentMethod:
          res?.resources?.isAllowedtoChangePaymentMethod?.toString()
            ? res?.resources?.isAllowedtoChangePaymentMethod
            : null,
        paymentMethodName: res?.resources?.paymentMethodName
          ? res?.resources?.paymentMethodName
          : "",
        debtorName: res?.resources?.debtorName
          ? res?.resources?.debtorName
          : "",
        paymentOptionId: res?.resources?.paymentOptionId
          ? res?.resources?.paymentOptionId
          : "",
        bdiNumber: res?.resources?.bdiNumber ? res?.resources?.bdiNumber : "",
        accountHolderName: res?.resources?.accountHolderName
          ? res?.resources?.accountHolderName
          : "",
        accountNo: res?.resources?.accountNo ? res?.resources?.accountNo : "",
        bankName: res?.resources?.bankName ? res?.resources?.bankName : "",
        bankBranchCode: res?.resources?.bankBranchCode
          ? res?.resources?.bankBranchCode
          : "",
        isPurchaseOrderExist: res?.resources?.isPurchaseOrderExist?.toString()
          ? res?.resources?.isPurchaseOrderExist
          : "",
        purchaseOrderNo: res?.resources?.purchaseOrderNo
          ? res?.resources?.purchaseOrderNo
          : "",
        purchaseOrderDate: res?.resources?.purchaseOrderDate
          ? new Date(res?.resources?.purchaseOrderDate)
          : null,
        debtorAccountDetailId: res?.resources?.debtorAccountDetailId || null,
      },
      { emitEvent: false }
    );
    this.onPatchFormArray(res);
  }

  onPatchFormArray(res) {
    res?.resources?.payments?.forEach((element) => {
      this.initFormArray({
        paidAmount: element?.paidAmount ? element?.paidAmount : "",
        paymentMethodId: element?.paymentMethodId
          ? element?.paymentMethodId
          : "",
        debitDate: element?.debitDate ? new Date(element?.debitDate) : null,
        canEdit: element?.canEdit,
        isDebitOrder: element?.isDebitOrder,
      });
    });
  }

  onValidatePaidAmountWithBalanceAmount() {
    let paidAmount = 0;
    let balance = 0;
    let missingValue = 0;
    this.getProcessPaymentFormArray.getRawValue()?.forEach((el: any) => {
      paidAmount += +el?.paidAmount;
    });
    if (
      paidAmount > this.config?.data?.paymentDetails?.resources?.balanceAmount
    ) {
      balance = toRoundOffWithMathRound(
        +paidAmount -
        +this.config?.data?.paymentDetails?.resources?.balanceAmount
      );
      missingValue =
        +this.getProcessPaymentFormArray.controls[0].get("paidAmount").value -
        +balance;
      paidAmount = +paidAmount - +balance;
    } else if (
      paidAmount < this.config?.data?.paymentDetails?.resources?.balanceAmount
    ) {
      balance =
        +this.config?.data?.paymentDetails?.resources?.balanceAmount -
        +paidAmount;
      missingValue = toRoundOffWithMathRound(
        +this.getProcessPaymentFormArray.controls[0].get("paidAmount").value +
        +balance
      );
      paidAmount = +paidAmount + +balance;
    }
    paidAmount = +toRoundOffWithMathRound(paidAmount);
    if (missingValue > 0) {
      this.getProcessPaymentFormArray.controls[0]
        .get("paidAmount")
        .setValue(+missingValue);
    }
    return (
      paidAmount == this.config?.data?.paymentDetails?.resources?.balanceAmount
    );
  }

  onSubmitDialog() {
    if (this.isSubmitted || (!this.processPaymentDialogForm?.valid && !this.processPaymentDialogForm?.disabled)) {
      this.processPaymentDialogForm?.markAllAsTouched();
      return;
    }
    if (!this.onValidatePaidAmountWithBalanceAmount()) {
      return;
    }
    this.isSubmitted = true;
    let reqObj = {
      bankBranch: this.processPaymentDialogForm.get("bankBranchCode").value,
      bankName: this.processPaymentDialogForm.get("bankName").value,
      billOfMaterialId: this.config?.data?.billOfMaterialId,
      createdUserId: this.config?.data?.userId,
      customerName: this.config?.data?.customerName,
      debitOrderRunCodeId: null,
      debtorAccountDetailId: this.processPaymentDialogForm.get("debtorAccountDetailId").value,
      designation: this.config?.data?.designation,
      isIncludePONumber: false,
      isMultiplePayament: false,
      isSinglePayment: false,
      notes: null,
      paymentDate: null,
      paymentMethodId: 2,
      poDate: null,
      poNumber: null,
      smsVerificationNumber: null,
      techJobCardPaymentDetails: [],
      totalAmount: this.processPaymentDialogForm.get("balanceAmount").value,
      transactionDescription: null,
    };
    this.getProcessPaymentFormArray.getRawValue()?.forEach((el) => {
      reqObj["techJobCardPaymentDetails"].push({
        paymentDate: this.momentService.localToUTC(el?.debitDate),
        paymentAmount: +el?.paidAmount,
        totalOutstandingAmount:
          this.processPaymentDialogForm.get("balanceAmount").value,
        paymentMethodId: el?.paymentMethodId,
      });
    });
    let formData = new FormData();
    formData.append("dto", JSON.stringify(reqObj));
    this.crudService
      .create(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_JOB_CARD_ACCEPTANCE_PAYMENT_PROCESS,
        formData
      )
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          if (res?.resources) {
            window.open(res?.resources, '_blank');
          }
          this.ref.close(true);
        }
        this.isSubmitted = false;
        this.rxjsService.setDialogOpenProperty(false);
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }
}
